export default __webpack_public_path__ + "static/media/nuclea.d5cd1e28.png";